export default __webpack_public_path__ + "static/media/777.fed287a0.gif";